module.exports = __webpack_public_path__ + "img/alquimistas-fotos.34dd3447.jpg";